import { computed, ref } from '@vue/composition-api'
import useStore from '../../../core/hooks/useStore'
import { requestsUseCase } from '../../../core/usecases'
import queries from './queries'

const useOverviewCard = () => {
    const { state } = useStore()
    const userId = computed(() => state.value.user.uid)
    const overviewCardData = ref([])
    const newPendings = ref(0)
    
    const initOverviewCardData = [
        {
            title: 'Pending Requests',
            icon: 'overview-card-pending-icon',
            count: 0,
            new: 0,
            location: 'requests',
            id: 'pending-requests-box'
        },
        {
            title: 'Campaigns to Post',
            icon: 'overview-card-accepted-icon',
            count: 0,
            location: 'updates',
            id: 'confirmed-campaigns-box'
        }
    ]
    overviewCardData.value = [...initOverviewCardData]
    requestsUseCase.getPendingRequests(queries.findPendingRequests(userId.value))
        .then(response => {
            newPendings.value = response.data.hits.filter(el => !el._source.seen).length
            overviewCardData.value[0].count = response.data.total.value
            overviewCardData.value[0].new = newPendings.value
        })
    requestsUseCase.getActualAcceptedRequests(queries.findActualConfirmedRequests(userId.value)) 
        .then(response => {
            overviewCardData.value[1].count = response.data.total.value
        })
    return {
        overviewCardData
    }
}

export default useOverviewCard